<p *ngIf="packagePrice"
	class="text text--hype-hero-headline">$<span>{{packagePrice}}</span>
</p>

<p *ngIf="purchasedSeperately"
	class="text text--subtext packagedSeperately">
	$<span>{{purchasedSeperately}}</span> when purchased seperately
</p>